import {
  usePathname as useLocalizedPathname,
  useRouter,
} from '@/i18n/navigation'
import { usePathname, useSearchParams } from 'next/navigation'
import { useCallback } from 'react'
import { updateHistoryState } from '../lib/utils/routing'

export const useDeleteSearchParam = () => {
  const searchParams = useSearchParams()
  const router = useRouter()
  const pathname = usePathname()
  const localizedPathname = useLocalizedPathname()

  const deleteSearchParam = useCallback(
    (
      key: string,
      { clientOnly }: { clientOnly: boolean } = { clientOnly: false },
    ) => {
      const query = new URLSearchParams(searchParams)
      query.delete(key)

      if (clientOnly) {
        updateHistoryState(`${pathname}?${query.toString()}`)
      } else {
        router.replace({
          pathname: `${localizedPathname}?${query.toString()}`,
        })
      }
    },
    [router, pathname, localizedPathname, searchParams],
  )

  return {
    searchParams,
    deleteSearchParam,
  }
}
